module.exports = __webpack_public_path__ + "static/media/HotMama.b2cb47e2.jpg";